import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { catchError, EMPTY, switchMap, throwError } from 'rxjs'
import { AuthService } from '../auth/auth.service'
import { Store } from '@ngrx/store'
import { ClientActions } from '../state/client/client.actions'
import { ConciergeAuthService } from '../auth/admin-auth.service'

let isRefreshing = false

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService)
	const conciergeAuthService = inject(ConciergeAuthService)
	const token = conciergeAuthService.getToken() ?? authService.getToken()
	const store = inject(Store)

	if (token) {
		req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
	}
	return next(req).pipe(
		catchError((err: unknown) => {
			if (err instanceof HttpErrorResponse) {
				// 403 ou 419: Fazer logout
				if (err.status === 403 || err.status === 419) {
					store.dispatch(ClientActions.logoutClient())
					return throwError(() => err)
				}

				// 401: Tentar refresh token
				if (err.status === 401) {
					if (req.url.includes('/concierge')) {
						return throwError(() => err)
					}
					// Verifica se tem refresh token disponível
					if (!authService.hasRefreshToken()) {
						authService.logout()
						store.dispatch(ClientActions.logoutClient())
						return throwError(() => err)
					}

					// Evita múltiplas chamadas simultâneas de refresh
					if (isRefreshing) {
						return EMPTY // Para requisições simultâneas, apenas cancela
					}

					isRefreshing = true

					return authService.refreshTokens().pipe(
						switchMap(authResponse => {
							// Sucesso no refresh: salva os novos tokens
							authService.setTokens(authResponse)
							isRefreshing = false

							// Refaz a requisição original com o novo token
							const newReq = req.clone({
								setHeaders: { Authorization: `Bearer ${authResponse.accessToken}` },
							})
							return next(newReq)
						}),
						catchError(refreshError => {
							// Falha no refresh: fazer logout
							isRefreshing = false

							if (
								refreshError instanceof HttpErrorResponse &&
								(refreshError.status === 401 || refreshError.status === 419)
							) {
								store.dispatch(ClientActions.logoutClient())
							}

							return throwError(() => refreshError)
						})
					)
				}
			}

			return throwError(() => err)
		})
	)
}
